<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Event Details</li>
                <li></li>
            </ul>
            <h2 i18n>Event Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>

                                <li>
                                    <i class='bx bx-current-location'></i>
                                    <span i18n>LOCATION</span>
                                    <a>{{event?.event_location}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span i18n>Contact</span>
                                    <a>{{event?.event_contact}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>EVENT DATE</span>
                                    <a>{{event?.event_date|date:'longDate'}}</a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{event?.title}}</h3>

                        <blockquote class="wp-block-quote" *ngIf="event?.text">
                            <h3 i18n>Event Details</h3>
                            <p>
                                {{event?.text}}
                            </p>
                            <figure class="pt-5">
                                <img [src]="imageURL+event?.image" style="max-height:25em" alt="image">
                            </figure>
    
                        </blockquote>



                    </div>

                </div>

            </div>
        </div>
    </div>
</div>